module.exports = __webpack_public_path__ + "static/media/jn.c552d055.svg";